export default "__VITE_ASSET__b6e3468e__"